export const GET_ASN_STATE = 'GET_ASN_STATE'
export const GET_ASN_STATE_EXITO = 'GET_ASN_STATE_EXITO'
export const GET_ASN_STATE_ERROR = 'GET_ASN_STATE_ERROR'
